'use strict';

function getVisibleMonths(months, year, now = new Date()) {
    const values = months || [];

    if (Number(year) !== now.getFullYear()) {
        return values;
    }

    return values.slice(0, now.getMonth() + 1);
}

module.exports = { getVisibleMonths };
